var sApp = sApp || {};

sApp.Test = library(function() {
    return {
        init: function () {
            this.elements = {
                root: $('.js-test')
            };

            this.points = {
                correct: 0,
                math: 0,
                logic: 0,
                ar: 0,
                rus: 0,
                conc: 0
            };

            if(!this.elements.root.length) return false;

            this._render();
            this._bind();
        },
        _render: function () {
            var questions = this.elements.root.find('.js-test-step').length,
                progress = $('.js-test-progress'),
                progressEl = '<span></span>';

            for (var i = 0; i < questions; i++) {
                progress.append(progressEl);
            }

            progress.find('span').eq(0).addClass('active');
        },
        _bind: function () {
            var _this = this,
                radioBtn = this.elements.root.find('.js-answers').find('input[type="radio"]');

            radioBtn.on('change', function () {
                _this.calcPoints($(this));
            });
        },
        calcPoints: function (elem) {
            var _this = this,
                current = elem.parents('.js-test-step'),
                type = elem.parents('.js-test-step').data('type');

            if (elem.data('correct')) {
                this.points.correct += 1;
                this.points[type] += 1;
            }

            this.nextQuestion(current);
        },
        nextQuestion: function (current) {
            var next = current.next(),
                index = next.index();

            current.removeClass('active');

            if (next.length) {
                next.addClass('active');
                this.changeCounter(index);
                sendGa('test', 'show', 'question - '+index);
            } else {
                this.calcResultPoints();
            }
        },
        changeCounter: function (index) {
            var _this = this,
                progress = $('.js-test-progress').find('span');

            progress.removeClass('active');
            progress.eq(index).addClass('active');
        },
        calcResultPoints: function () {
            var _this = this;

            if (_this.points.correct < 3) {
                _this.showTestResult('_uncapable');

                sendGa('test', 'show', 'result - uncapable');
            } else if (_this.points.correct > 7){
                _this.showTestResult('_capable');

                sendGa('test', 'show', 'result - capable');
            } else if (_this.points.correct > 2 && _this.points.correct < 8 && _this.checkSkills()){
                _this.showTestResult('_creator');

                sendGa('test', 'show', 'result - creator');
            } else {
                if (_this.points.ar == 2 || _this.points.rus == 2) {
                    _this.showTestResult('_creator');

                    sendGa('test', 'show', 'result - creator');
                } else if (_this.points.math == 2 || _this.points.conc == 2) {
                    _this.showTestResult('_buyer');

                    sendGa('test', 'show', 'result - buyer');
                } else if (_this.points.logic == 2) {
                    _this.showTestResult('_account');

                    sendGa('test', 'show', 'result - account');
                }
            }
        },
        checkSkills: function () {
            if (this.points.math < 2 && this.points.ar < 2 && this.points.logic < 2 && this.points.rus < 2 && this.points.conc < 2) {
                return 1;
            }
        },
        parseUrl: function () {
            var _this = this,
                origin =  window.location.origin,
                path = window.location.pathname,
                url;

            if(path.indexOf(".html") > -1 || path.indexOf(".php") > -1) {
                var parts = path.split("/"),
                    pathPart = parts.slice(0, -1).join('/');

                if (parts.length > 2){
                    url = origin + pathPart;
                } else {
                    url = origin;
                }
            } else {
                url = origin + path;
            }

            return url;
        },
        showTestResult: function (result) {
            var url = this.parseUrl();

            window.location.replace(url + '/result'+result+'.html');
        }
    };
}());